import { z } from 'zod';
import {
    ImageFileExtension,
    VideoFileExtension,
    AudioFileExtension,
} from '../../../general';

export const StringSchema = z.string().trim();

export const EmailSchema = StringSchema.email().trim().toLowerCase();

export const ImageFileExtensionSchema = z.nativeEnum(ImageFileExtension);

export const VideoFileExtensionSchema = z.nativeEnum(VideoFileExtension);

export const AudioFileExtensionSchema = z.nativeEnum(AudioFileExtension);

export const PaginationInputSchema = z.object({
    page: z.number().int().positive(),

    /**
     * @max 100
     * @default 10
     */
    pageSize: z.number().int().positive().max(100).optional().default(10),

    /**
     * Token obtained from the previous call.
     */
    lastToken: StringSchema.optional().nullable(),
});

export const InfiniteScrollingInputSchema = z.object({
    /**
     * Cursor obtained from a previous call. The result will be
     * items after this cursor. If ommitted, the result will be
     * items from the beginning of the list.
     */
    cursor: StringSchema.optional().nullable(),

    /**
     * The number of items to return.
     *
     * @max 100
     * @default 10
     */
    limit: z.number().int().positive().max(100).optional().default(10),
});

export const ObjectIdSchema = z
    .string()
    .regex(/^[0-9a-fA-F]{24}$/, 'The provided id has an invalid format.');

export const ImageUploadInputSchema = z.object({
    fileExtension: ImageFileExtensionSchema,
});

export const VideoUploadInputSchema = z.object({
    fileExtension: VideoFileExtensionSchema,
    originalFileName: z.string().optional(),
});

export const AudioUploadInputSchema = z.object({
    fileExtension: AudioFileExtensionSchema,
    originalFileName: z.string().optional(),
});
